// @ts-nocheck
/* eslint-disable */
export const outlineForbiddenIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m6.9-17-14 14"/></svg>`,
    name: 'outline-forbidden' as const
};